import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {CadCadastroAnexoOnlineService} from 'app/shared/services/cad-cadastro-anexo-online.service'
import {CadCadastroAnexoOnline} from 'app/shared/interfaces/cad-cadastro-anexo-online'
import { BehaviorSubject } from 'rxjs';
import { CadArquivoOnline } from 'app/shared/interfaces/cad-arquivo-online';
import { ProdutoAnexoOnline } from 'app/shared/interfaces/produto-anexo-online';
import { CadAgendaAnexoOnline } from 'app/shared/interfaces/cad-agenda-anexo-online';
import { ProdutoAnexoOnlineService } from 'app/shared/services/produto-anexo-online.service';
import { CadAgendaAnexoOnlineService } from 'app/shared/services/cad-agenda-anexo-online.service';
import { CadArquivoOnlineService } from 'app/shared/services/cad-arquivo-online.service';
import * as pdfjs from 'pdfjs-dist';

@Component({
  selector: 'app-cadastro-file-view',
  templateUrl: './cadastro-file-view.component.html',
  styleUrls: ['./cadastro-file-view.component.scss']
})
export class CadastroFileViewComponent implements OnInit {


  @ViewChild('pdfViewer', { static: true }) pdfViewer: ElementRef;

  @Input('cad-anexo')
  cadastroAnexo: CadCadastroAnexoOnline;

  @Input('prod-anexo') 
  produtoAnexo:ProdutoAnexoOnline;


  @Input('agenda-anexo') 
  agendaAnexo: CadAgendaAnexoOnline;


  isImage$ : BehaviorSubject<Boolean> = new BehaviorSubject<Boolean>(false);

  cadArquivoOnline$ : BehaviorSubject<CadArquivoOnline> = new BehaviorSubject<CadArquivoOnline>(null);

  cadArquivoOnline : CadArquivoOnline;

  pdfDoc: any;
  page = 1;
  startX: number;
  startY: number;
  width: number;
  height: number;
  isDrawing: boolean = false;
  altura = 130;

  pdfX = 0;
  pdfY = 0;
  currentPage = 1;
  totalPages = 1;

  constructor(private fb: FormBuilder
    , private anexoService: CadCadastroAnexoOnlineService 
     , private produtoAnexoService : ProdutoAnexoOnlineService
     , private cadAgendaAnexoService: CadAgendaAnexoOnlineService,
     private cadArquivoOnlineService : CadArquivoOnlineService ) { }

  ngOnInit(): void {
   
    this.cadArquivoOnline$.subscribe(data => {
      if (data !== null && data !== undefined) {
        this.isImage$.next(data?.contentType?.includes('image/'));

        if (this.isPdf(data.contentType)) {
          this.renderPdf(data.presignedUrl);
        }
      }
    });

    
    if(this.cadastroAnexo ){
      this.anexoService.getCadCadastroAnexo(this.cadastroAnexo.id, true).subscribe(an=>{
        this.cadastroAnexo  = an;
        this.cadArquivoOnline$.next(an.cadArquivoOnline);
        this.isImage$.next(an?.cadArquivoOnline?.contentType?.includes('image/'));
      })
    }else if( this.produtoAnexo){
      this.produtoAnexoService.getProdutoAnexo(this.produtoAnexo.id, true).subscribe(an=>{
        this.produtoAnexo  = an;
        this.cadArquivoOnline$.next(an.cadArquivoOnline);
        this.isImage$.next(an?.cadArquivoOnline?.contentType?.includes('image/'));
      })
    }else if( this.agendaAnexo){
      this.cadAgendaAnexoService.getCadAgendaAnexo(this.agendaAnexo.id, true).subscribe(an=>{
        this.agendaAnexo  = an;
        this.cadArquivoOnline$.next(an.cadArquivoOnline);
        this.isImage$.next(an?.cadArquivoOnline?.contentType?.includes('image/'));
      })
    }

  }

  isPdf(contentType: string | null | undefined): boolean {
    // Tratar se estiver nulo ou indefinido
    if (contentType === null || contentType === undefined) {
      return false;
    }
  
    // Verificar se o tipo de conteúdo é 'application/pdf'
    return contentType.includes('application/pdf');
  }
  
  private renderPdf(presignedUrl: string): void {
    pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';

    pdfjs.getDocument(presignedUrl).promise.then((pdf) => {
      this.pdfDoc = pdf;
      this.totalPages = pdf.numPages;
      if (this.page > this.totalPages) {
        this.getPage(this.totalPages);
      } else {
        this.getPage(this.page);
      }
    });
  }

  private getPage(page: any) {
    this.currentPage = page;
    this.pdfDoc.getPage(page).then(page => {
      this.page = page;
      // Render the PDF page on a canvas element
      const canvas = this.pdfViewer.nativeElement;
      const context = canvas.getContext('2d');
      const viewport = page.getViewport({ scale: 1.5 });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      page.render({ canvasContext: context, viewport: viewport });
    });
  }
  
  previousPage() {
    this.getPage(this.currentPage - 1);
  }

  nextPage() {
    this.getPage(this.currentPage + 1);
  }

  firstPage() {
    this.getPage(1);
  }

  lastPage() {
    this.getPage(this.pdfDoc.numPages);
  }

 

  

}
